import { region } from './env.js';

const currency = new Intl.NumberFormat(region.locale, {
  style: 'currency',
  currency: region.currency,
  // Whole-dollar prices read as "$650"; prices with cents keep both digits.
  trailingZeroDisplay: 'stripIfInteger',
});

export function formatPrice(amount: number): string {
  return currency.format(amount);
}
